import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import updateStorecreatorData from '../_update_storecreator_data';

/**
 * カテゴリ更新注意モーダル
 */
export default {
    name: 'modal-update-category-confirm',
    template: '#modal_update_category_confirm_template',
    data() {
        return {
            // カテゴリデータ
            categories: [],
        };
    },
    props: {
        // 選択されたパスリスト
        path_config: {
            type: Array,
            default: () => ([])
        },
    },
    components: {
        // ストアクリエイターからデータを取得するコンポーネント
        'update-storecreator-data': updateStorecreatorData,
    },
    mixins: [
        modalMixin,
        flashMessageMixin,
    ],
    watch: {
        // パス設定セットされたら(初回のみ)
        path_config: function (newValues, oldValue) {
            if (!oldValue.length) {
                this.openModal();
            }
        },
    },
    methods: {
        // path_configの設定値が一つでも存在しなかったらモーダルを開く
        openModal: function () {
            for (const i in this.path_config) {
                const hasCotegory = this.categories.filter(category => {
                    return category.page_key === this.path_config[i];
                }).length > 0;
                if (!hasCotegory) {
                    this.open();
                    break;
                }
            }
        },
        // カテゴリデータをセット
        setCategories: function (categories) {
            this.categories = categories;
        },
        // カテゴリを更新してカテゴリが補完されたらリロード
        reload: function () {
            if (this.modal_opened) {
                window.location.reload();
            }
        }
    }
};
